import { Currencies } from '@constants/enums';
import fundingSvc from '@efex-services/funds/fundingSvc';
import type {
  AddFundsUsaInstructions,
  AddFundsUsaInstructionsRequest,
} from '@efex-services/funds/types';
import type { UseApiCallProps } from '@pages/lending/types';
import { selectBusiness } from '@pages/profile/store/selectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useApiCall } from 'use-api-call';
import type {
  UseHandleInstructionsProps,
  UseHandleInstructionsResponse,
} from '../types';

const useHandleInstructions = ({
  initCurrency = Currencies.USD,
  initWalletId = 0,
}: UseHandleInstructionsProps): UseHandleInstructionsResponse => {
  const company = useSelector(selectBusiness);
  const { enterpriseId } = company || {};
  const [currency, setCurrency] = useState<Currencies>(initCurrency);
  const [walletId, setWalletId] = useState<number>(initWalletId);

  const {
    loading,
    data: instructions,
    invoke: addFundsUsaInstructions,
  }: UseApiCallProps<
    AddFundsUsaInstructions,
    AddFundsUsaInstructionsRequest
  > = useApiCall((values) => fundingSvc.addFundsUsaInstructions(values));

  useEffect(() => {
    addFundsUsaInstructions({
      enterpriseId: enterpriseId || '0',
      currency,
      walletId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enterpriseId, currency, walletId]);

  return {
    loading,
    currency,
    instructions,
    setCurrency,
    setWalletId,
  };
};

export default useHandleInstructions;
